import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "reactstrap";
import { fetchDocsStart } from "../../../../store/general/documents/actions.js";
import BillingForm from "./BillingForm.js";

const CheckKYC = ({ t, setIsFirstStepValid, setPaymentPayload }) => {
  const { kycApproved, loading } = useSelector((state) => state?.Profile.clientData.stages);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchDocsStart());
  }, []);

  const isApproved = kycApproved;

  if (loading) {
    return null;
  }
  
  if (!isApproved) {
    return (
      <div className="mt-4">
        <Alert color="warning">
          <h5 className="alert-heading">{t("Documents Required")}</h5>
          <p>
            {t("Please submit all required KYC documents for verification.")}
          </p>
        </Alert>
      </div>
    );
  }

  // If KYC is approved, show the billing form
  if (isApproved) {
    return (
      <BillingForm
        t={t}
        setIsFirstStepValid={setIsFirstStepValid}
        setPaymentPayload={setPaymentPayload}
      />
    );
  }
  
  return null;
};

export default CheckKYC;